export * from './lib/service/tag-field-generator.service';

export * from './lib/tags.module';
